import { IncomingEventTypes } from './definitions/base-event';
import { RefreshData } from './definitions/refresh-data';

export type AllIncomingEvents = RefreshData;

export function isValidIncomingEvent(event: unknown): event is AllIncomingEvents {
  if (typeof event !== 'object' || event === null) {
    return false;
  }

  if (!('type' in event)) {
    return false;
  }

  const validTypes = Object.values(IncomingEventTypes) as string[];
  if (!validTypes.includes((event as { type: unknown }).type as string)) {
    return false;
  }

  return true;
}
